import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import styles from "./GuestWeddingWebsite.module.css";
import { Box, Steps } from "../../../components";
import profileImg from "../../../assets/live.png";
import GuestScreen1 from "./GuestScreen1/GuestScreen1";
import GuestScreen2 from "./GuesrScreen2/GuestScreen2";
import GuestScreen3 from "./GuestScreen3/GuestScreen3";
import GuestScreen4 from "./GuestScreen4/GuestScreen4";
import GuestScreen5 from "./GuestScreen5/GuestScreen5";
import GuestScreen6 from "./GuestScreen6/GuestScreen6";
import { EventMiddleware } from "../../../Store/Middlewares/EventMiddleware";

const GuestWeddingWebsite = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(true);
  //   const [profileImg, setProfileImg] = useState();s
  const EventDetails = useSelector(
    (state) => state?.GuestReducer?.EventDetails
  );
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);
  const dispatch = useDispatch();

  const stepLinks = [
    {
      id: 1,
    },
    {
      id: 2,
    },
    {
      id: 3,
    },
    {
      id: 4,
    },
    {
      id: 5,
    },
    {
      id: 6,
    },
  ];

  useEffect(() => {
    dispatch(EventMiddleware.getWeddingWebsite(EventDetails?.id))
      .then(() => {
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);
  return (
    <div>
      {/* <h1>Wedding Website</h1> */}
      <Steps
        stepLinks={stepLinks}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        stepperClass={styles.stepperCont}
      />
      <Box boxClass={styles.mainCont}>
        <div
          className={styles.backImg}
          style={
            WeddingWeb?.background_image
              ? {
                  backgroundImage: `linear-gradient(rgba(255,255,255,0.6 ), rgba(255,255,255,0.6)),url(${WeddingWeb?.background_image})`,
                }
              : {}
          }
        >
          {currentStep == 1 ? (
            <GuestScreen1
              setCurrentStep={setCurrentStep}
              profileImg={profileImg}
            />
          ) : currentStep == 2 ? (
            <GuestScreen2
              setCurrentStep={setCurrentStep}
              profileImg={profileImg}
            />
          ) : currentStep == 3 ? (
            <GuestScreen3
              setCurrentStep={setCurrentStep}
              profileImg={profileImg}
            />
          ) : currentStep == 4 ? (
            <GuestScreen4
              setCurrentStep={setCurrentStep}
              profileImg={profileImg}
            />
          ) : currentStep == 5 ? (
            <GuestScreen5
              setCurrentStep={setCurrentStep}
              profileImg={profileImg}
            />
          ) : currentStep == 6 ? (
            <GuestScreen6
              setCurrentStep={setCurrentStep}
              profileImg={profileImg}
            />
          ) : null}
        </div>
      </Box>
    </div>
  );
};

export default GuestWeddingWebsite;
